//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class RepertoireDistinctDisplayItem extends ItemBase {
    DistinctComposers: string[] = [];
    DistinctGenres: string[] = [];
    DistinctTitles: string[] = [];
    DistinctDifficulty: string[] = [];
    DistinctSource: string[] = [];
    DistinctLanguage: string[] = [];
    DistinctInstrument: string[] = [];

    constructor(initializer?: Partial<RepertoireDistinctDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "RepertoireDistinctDisplayItem";
}
